import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

function BookGuideModal({ show, onHide }) {
    const { t } = useTranslation();

    return (
        <Modal
            show={show}
            onHide={onHide}
            size='xl'
            centered
            backdrop='static'
            keyboard
        >
            <Modal.Header closeButton>
                <Modal.Title>{t('bookGuide.title')}</Modal.Title>
            </Modal.Header>
            <Modal.Body className='p-0' style={{ height: '80vh' }}>
                <iframe
                    title={t('nav.bookLayoutGuide')}
                    src='/genai/book-guide'
                    style={{ width: '100%', height: '100%', border: '0' }}
                />
            </Modal.Body>
            <Modal.Footer>
                <Button variant='secondary' onClick={onHide}>{t('common.close')}</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default BookGuideModal;